import accountEntries from './accountEntries.js';
import accountTransactions from './accountTransactions.js';
import accountPersonalDetails from './accountPersonalDetails.js';
import accountStatus from './accountStatus.js';
import accountSpendLimit from './accountSpendLimit.js';
import accountNotifications from './accountNotifications.js';
import accountPasswordChange from './accountPasswordChange.js';
import createNotification from './createNotification';
import accountIDV from './accountIDV';

const account = {
    init: function() {
        const accountSection = document.getElementById("account--landing");
        if (!accountSection) {
            return;
        }

        // initialise sub components
        accountEntries.init();
        accountTransactions.init();
        accountPersonalDetails.init();
        accountStatus.init();
        accountSpendLimit.init();
        accountNotifications.init();
        accountPasswordChange.init();
        accountIDV.init();

        // check popups to display
        const sectionType = accountSection.dataset.section;
        if (sectionType === "personal-details" && accountSection.dataset.authenticated == "1") {
            accountPersonalDetails.showPersonalDetails();
        }
        if (sectionType === "upload" && accountSection.dataset.authenticated == "1") {
            accountIDV.showIDVPopup();
        }
        if (sectionType === "spend-limit" && accountSection.dataset.authenticated == "1") {
            accountSpendLimit.showAccountSpendLimitPopup();
        }
        if (sectionType === "status" && accountSection.dataset.authenticated == "1") {
            accountStatus.showAccountStatusPopup();
        }
        if (sectionType === "notifications" && accountSection.dataset.authenticated == "1") {
            accountNotifications.showNotificationsPopup();
        }

        const actionType = accountSection.dataset.action;
        if (actionType === "dpm") {
            createNotification("Your payment method has been removed");
        }
    }
};

export default account;


// WEBPACK FOOTER //
// ./assets/src/js/classes/account.js